export function checkBadWords(text,curr_html){
    $.ajax({
        method: 'post',
        url: page_ajax.wp_ajax_file,
        dataType: 'json',
        data: {
            action: 'badWordsFilter',
            data: text
        },
        success: function(response) {
            var parent_div = $(curr_html).closest('.form-group,.input-group');
            if($(curr_html).closest('.form-group,.input-group').find('.imoment_errors').length){
                $(curr_html).closest('.form-group,.input-group').find('.imoment_errors').remove();
            }
            if(response.ok == 0 && response.filter =='BW'){   
                $(parent_div).append(`<div class='imoment_errors imoment-error-field'>
                <span class='error'>  Sorry, we have detected words that are not allowed in the checklist you have created. Remove to proceed:${response.message} </span>
                </div>`)
            }
            if(response.ok == 0 && response.filter =='NA'){   
                $(parent_div).append(`<div class='imoment_errors imoment-error-field'>
                <span class='error'>  Only English letters, numbers, and certain special characters are allowed. </span>
                </div>`)
            }
        }
    });
}

export function submitFormCheckBadWords(curr_node,curr_evt,submit_btn){
    var formData = $( curr_node ).serialize();
        //check the badwords first with ajax
        $.ajax({
            method: 'post',
            url: page_ajax.wp_ajax_file,
            dataType: 'json',
            data: {
                action: 'badWordsFilter',
                // searchTerm: $('#search-input-id').val(),
                post_data: formData
            },
            success: function(response) {
                if (response.ok == 1) {
                    curr_evt.currentTarget.submit();
                    // console.table(response);
                }else{
                    var btn_div = $(submit_btn).parent()[0];
                    if ($('.imoment_errors').length) {
                        $('.imoment_errors').remove();
                      }
                    if(response.ok == 0 && response.filter =='BW'){
                        $(`<div class='imoment_errors mt-4'>
                            <span class='error'>  Sorry, we have detected words that are not allowed in the checklist you have created. Remove to proceed: ${response.message}</span>
                            </div>`).insertAfter(btn_div);
                    }
                    if(response.ok == 0 && response.filter =='NA'){
                        $(`<div class='imoment_errors'>
                            <span class='error'>  Only English letters, numbers, and certain special characters are allowed.</span>
                            </div>`).insertAfter(btn_div);
                    }

                }
            },
            error: (response) => {
                console.log("Error");
                console.table(response);
            }
        })
}
